import React, { useEffect, useState } from "react";
import { Box, Paragraph } from "grommet";
import { times } from "../../../utils/date";
import { useParams } from "react-router-dom";
import { NewsBanner } from "../../NewsBanner";
export var NewsContent = function NewsContent(_ref) {
  var api = _ref.api,
    loader = _ref.loader,
    renderHTML = _ref.renderHTML,
    tagManager = _ref.tagManager,
    newsList = _ref.newsList,
    loadNews = _ref.loadNews;

  var _useParams = useParams(),
    id = _useParams.id;

  var _useState = useState(),
    news = _useState[0],
    setNews = _useState[1];

  useEffect(
    function () {
      if (!news) {
        loadNews();
        setNews(
          newsList.find(function (item) {
            return item.public_id === id;
          })
        );
        tagManager();
      }
    },
    [newsList]
  );
  if (!news)
    return /*#__PURE__*/ React.createElement(
      Box,
      {
        fill: true,
        flex: true,
        justify: "center",
        alignSelf: "center",
      },
      loader
    );
  else
    return /*#__PURE__*/ React.createElement(
      React.Fragment,
      null,
      /*#__PURE__*/ React.createElement(
        Box,
        {
          key: news.public_id,
        },
        /*#__PURE__*/ React.createElement(NewsBanner, {
          image: api + news.banners.main,
          heading: news.headline,
          paragraph: news.subtitle,
          publication_date: times.getFullDate(news.publication_date),
        }),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            width: {
              max: "1200px",
            },
            alignSelf: "center",
            pad: {
              horizontal: "medium",
            },
          },
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "small",
              fill: true,
              style: {
                lineHeight: "1.5",
                whiteSpace: "pre-line",
              },
            },
            renderHTML(news.text)
          )
        )
      )
    );
};
